export default {
    uniforms: {
        uTime: {
            type: 'float',
            value: 0
        },
    },
    attributes: {
        velocityStartTime: {  
                type: 'vec4'  
        }
    },
    vertex: {
        code: `
            vec3 vel = velocityStartTime.xyz ;
            float startTime = velocityStartTime.w ;
            float timeElapsed = uTime - startTime;
            transformed.x += vel.x * timeElapsed ;
            transformed.y += vel.y * timeElapsed  ;
            transformed.z += vel.z * timeElapsed  ;

            mvPosition = vec4( transformed, 1.0 );
            mvPosition = modelViewMatrix * mvPosition;
            gl_Position = projectionMatrix * mvPosition;
            
        `
    }
  
}